<script lang="ts" setup>
import { processAndUploadImage } from '../page-builder'

import type { PageElementDataOfType } from '../page-builder'

const tenant = useTenant()

const data = defineModel<PageElementDataOfType<'image'>>('data', { required: true })

const uploading = ref(false)
const uploadError = ref('')
const uploadProgress = ref(0)

function chooseImage() {
  const input = document.createElement('input')
  input.type = 'file'
  input.accept = 'image/*'

  input.addEventListener(
    'change',
    async () => {
      const file = input.files?.[0]
      if (!file) return

      uploading.value = true
      uploadProgress.value = 0
      uploadError.value = ''

      const url = await processAndUploadImage(file, tenant, (progress) => {
        uploadProgress.value = progress * 100
      })

      if (url) {
        data.value.url = url
      } else {
        uploadError.value = 'Beim Upload ist ein Fehler aufgetreten.'
      }

      uploading.value = false
    },
    { once: true },
  )

  input.click()
}
</script>

<template>
  <div class="flex items-center justify-center py-1">
    <div v-if="!uploading" class="flex flex-col items-center">
      <TuiButton @click="chooseImage">
        <template #icon="iconProps">
          <IMingcuteUpload2Fill v-bind="iconProps" />
        </template>
        Bild {{ data.url ? 'ersetzen' : 'auswählen' }}
      </TuiButton>

      <p class="text-xs text-red-500">{{ uploadError }}</p>
    </div>

    <div v-else>
      <p class="text-xs text-center font-medium mb-0.5">Hochladen...</p>

      <div class="w-64 rounded-full overflow-hidden">
        <TuiProgressLinear :value="uploadProgress" class="w-full" color="indigo" />
      </div>
    </div>
  </div>
</template>
